const getToken = () => {
  return JSON.parse(localStorage.getItem("key"));
};

// const getUserId = () => {
//   return Number(localStorage.getItem("userId"));
// };

const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
  authorization: "",
};

export const getDepartments = () => async (dispatch) => { 
  let SERVER_URL = process.env.REACT_APP_API_URL;
  await fetch(SERVER_URL + `api/common/department_list`, {
    method: "GET",
    headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
  })
    .then((res) => res.json())
    .then((data) => {
      dispatch({
        type: "GET_DEPARTMENTS",
        payload: data.result,
      });
    });
};

export const getGroups = () => async (dispatch) => {
  let SERVER_URL = process.env.REACT_APP_API_URL;
  await fetch(SERVER_URL + `api/group`, {
    method: "GET",
    headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
  })
    .then((res) => res.json())
    .then((data) => {
      dispatch({
        type: "GET_GROUPS",
        payload: data.data,
      });
    });
};
export const getSkillSetByDepartment = (department_id) => async (dispatch) => {
  let SERVER_URL = process.env.REACT_APP_API_URL;
  if(department_id=='' || department_id==null || department_id==undefined)
  return false;
  await fetch(SERVER_URL + `api/group/skillSet/department/${department_id}`, {
    method: "GET",
    headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
  })
    .then((res) => res.json())
    .then((data) => {
      dispatch({
        type: "GET_Skill_Set_With_Department",
        payload: data.data,
      });
    });
};

export const getSkills = () => async (dispatch) => {
  let SERVER_URL = process.env.REACT_APP_API_URL;
  await fetch(SERVER_URL + `api/group/skill/all`, {
    method: "GET",
    headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
  })
    .then((res) => res.json())
    .then((data) => {
      dispatch({
        type: "GET_SKILLS",
        payload: data.data,
      });
    });
};

export const getGroupsWithSkills = () => async (dispatch) => {
  let SERVER_URL = process.env.REACT_APP_API_URL;
  await fetch(SERVER_URL + `api/group/skill/distinct`, {
    method: "GET",
    headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
  })
    .then((res) => res.json())
    .then((data) => {
      let obj = {};
      let dept = {};
      let group = {};
      data.data.map((item) => {
        const { dept_id, group_id, skill_id, skill_name } = item;
        if (dept_id in obj)
          obj[dept_id].push({ dept_id, group_id, skill_id, skill_name });
        else obj[dept_id] = [{ dept_id, group_id, skill_id, skill_name }];
      });
      dispatch({
        type: "GET_GROUPS_WITH_SKILLS",
        payload: obj,
      });
    });
};

export const setSearchByDeptName = (state) => async (dispatch) => {
  dispatch({
    type: "SET_SEARCH_DEPT_NAME",
    payload: state,
  });
};

export const setSearchByDeptId = (state) => async (dispatch) => {
  dispatch({
    type: "SET_SEARCH_DEPT_ID",
    payload: state,
  });
};
